import React from "react";

export default function InstallPWAButton() {
  const [deferred, setDeferred] = React.useState(null);
  const [installed, setInstalled] = React.useState(false);

  React.useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setInstalled(true);
    }
    const handleInstall = () => setInstalled(true);
    window.addEventListener("appinstalled", handleInstall);
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => {
      window.removeEventListener("appinstalled", handleInstall);
      window.removeEventListener("beforeinstallprompt", onPrompt);
    };
  }, []);

  if (installed || !deferred) return null;

  return (
    <button
      className="btn success small"
      onClick={async () => {
        deferred.prompt();
        const choice = await deferred.userChoice;
        if (choice.outcome === "accepted") setDeferred(null);
      }}
    >
      نصب
    </button>
  );
}
